import { render, staticRenderFns } from "./chemicalDetail.vue?vue&type=template&id=63d59a53&"
import script from "./chemicalDetail.vue?vue&type=script&lang=js&"
export * from "./chemicalDetail.vue?vue&type=script&lang=js&"
import style0 from "./chemicalDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chemicalDetail.vue"
export default component.exports